module.exports = __webpack_public_path__ + "img/our-girls.7bb679fd.svg";